export const PASSWORD_DELAY = 1000;
